import React from "react";
import type { TranslationKey } from "../../../../api/useTranslations";
import t from "../../../../i18n";

export const useTranslationTools = () => {
  const matchTranslationKey = React.useCallback((key: TranslationKey) => {
    switch (key) {
      case "REPARABILITY_0":
        return t("customization.table.translation.reparability_0");
      case "REPARABILITY_1":
        return t("customization.table.translation.reparability_1");
      case "REPARABILITY_2":
        return t("customization.table.translation.reparability_2");
      case "TYPE":
        return t("customization.table.translation.type");
      case "LOSSES":
        return t("customization.table.translation.losses");
      case "LOSS":
        return t("customization.table.translation.loss");
      case "EXPLAINED":
        return t("customization.table.translation.explained");
      case "UNEXPLAINED":
        return t("customization.table.translation.unexplained");
      case "AVERAGE":
        return t("customization.table.translation.average");
      case "DASHBOARD":
        return t("customization.table.translation.dashboard");
      case "DASHBOARDS":
        return t("customization.table.translation.dashboards");
      default:
        throw new Error(key satisfies never);
    }
  }, []);

  return { matchTranslationKey };
};
